import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { RouterProvider } from '@tanstack/react-router';
import { AlertManager } from '@yembo/yemblocks-core';
import { createRoot } from 'react-dom/client';
import { sendMessage } from 'src/react/_sw/Messenger';
import { queryClient } from './queries';
import { OnlineStatusProvider } from './react/_sw/OnlineStatusProvider';
import * as serviceWorkerRegistration from './react/_sw/serviceWorkerRegistration';
import { router } from './router';
import { onDocumentLoad } from './util/onDocumentLoad';

import './analytics/logRocket';
import './_import.scss';
import { BuildInfo } from './react/_shared/BuildInfo';

const reactQueryDebuggerActive = import.meta.env.REACT_APP_QUERY_DEBUGGER === 'true';

onDocumentLoad(); // put all one-time setup actions here

const root = createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <>
    <BuildInfo />
    <QueryClientProvider client={queryClient}>
      <OnlineStatusProvider>
        <RouterProvider router={router} />
        <AlertManager duration={7 * 1000} shouldReplaceDuplicates withAnimation />
        {reactQueryDebuggerActive && <ReactQueryDevtools initialIsOpen={false} position='bottom' />}
      </OnlineStatusProvider>
    </QueryClientProvider>
  </>
);

serviceWorkerRegistration.register({
  onUpdate: () => sendMessage('update_ready', null),
});
